module.exports = __webpack_public_path__ + "static/media/admin-image.378670c4.png";